import React from 'react'
import { useAtomValue } from 'jotai'
import { useTranslation } from 'react-i18next'
import { ActionList, ActionListChildren, Box, Button, Icon, Highlight } from '@node-space/ui-components'
import { contactInstrumentActionAtom } from 'pages/Contacts/atoms/contactAtoms'
import { BeneficiaryDeprecationCallout } from './BeneficiaryDeprecationCallout'

type ContactOrBeneficiarySelector = {
  onContactOrBeneficiaryClick: (value: string) => void
}

export enum ContactOrBeneficiary {
  CONTACT = 'CONTACT',
  BENEFICIARY = 'BENEFICIARY',
}

export const ContactOrBeneficiarySelector = ({
  onContactOrBeneficiaryClick,
}: ContactOrBeneficiarySelector) => {
  const { t } = useTranslation()
  const contactInstrumentAction = useAtomValue(contactInstrumentActionAtom)

  const actionListItems: ActionListChildren[] = [
    {
      id: 'contact-bank-account-selector',
      title: 'Contact',
      testId: 'contact-bank-account-selector',
      Avatar: <Button variant="ghost" iconElement={<Icon name="UserCircle" size="large" />} />,
      BodyPre: t('wallets.fiatSend.payToContact'),
      transparent: true,
      onItemClick: () => onContactOrBeneficiaryClick?.(ContactOrBeneficiary.CONTACT),
    },
    {
      id: 'beneficiary-selector',
      title: 'Beneficiary',
      testId: 'beneficiary-selector',
      Avatar: <Button variant="ghost" iconElement={<Icon name="Bank" size="large" />} />,
      BodyPost: t('wallets.fiatSend.payToBeneficiary'),
      transparent: true,
      onItemClick: () => onContactOrBeneficiaryClick?.(ContactOrBeneficiary.BENEFICIARY),
      HeaderHighlightRight: <Highlight type="warning" variant="emphasis">{t('wallets.fiatSend.leavingSoon')}</Highlight>
    },
  ]

  return (
    <Box>
      <ActionList border={false} id="contact-or-beneficiary-selector" items={actionListItems} />
      <Box flexCol gapY={20}  paddingY={20}>
        <Box flexCol justify="start">
          <BeneficiaryDeprecationCallout />
        </Box>
       <Box justify="center">
        <Button
            testId="cancel"
            variant="secondary"
            onClick={() => {
              contactInstrumentAction?.onClose()
            }}
          >
            {t('cancel')}
        </Button>
       </Box>
      </Box>
    </Box>
  )
}
